// src/pages/HomePage.js
import React from 'react';
import Dashboard from './Dashboard';
import LandingPage from './LandingPage';

const HomePage = ({ user, openAuth, onUpdate, toast }) => {
  return user ? (
    <Dashboard user={user} onUpdate={onUpdate} toast={toast} />
  ) : (
    <LandingPage openAuth={openAuth} />
  );
};

export default HomePage;
